import type { ReactNode } from "react"
import type { ScenarioDraft } from "@/entities/bot-builder"
import { ScenarioPicker } from "@/features/choose-bot-scenario"
import { TableSkeleton } from "@/shared/ui/empty-state"
import { LoadSwap } from "@/shared/ui/load-swap"
import { type ScenarioDraftState, useBotWorkspace } from "../model/bot-workspace-context"
import { WorkspaceSection } from "./workspace-section"

export type LoadedDraft = ScenarioDraftState & { draft: ScenarioDraft }

/** Разделы конструктора работают со сценарием бота: без сценария его здесь же создают, пока грузится: скелет. */
export function WithDraft({
	title,
	subtitle,
	children,
}: {
	title: string
	subtitle?: ReactNode
	children: (state: LoadedDraft) => ReactNode
}) {
	const { bot, draft } = useBotWorkspace()
	if (!draft) {
		return (
			<WorkspaceSection
				title={title}
				subtitle="Воронки, меню и группы бота хранятся в сценарии. Создайте его, чтобы начать."
			>
				<div className="max-w-xl">
					<ScenarioPicker bot={bot} />
				</div>
			</WorkspaceSection>
		)
	}
	return (
		<LoadSwap loading={!draft.draft} fill>
			{draft.draft ? (
				children({ ...draft, draft: draft.draft })
			) : (
				<WorkspaceSection title={title} subtitle={subtitle}>
					<TableSkeleton />
				</WorkspaceSection>
			)}
		</LoadSwap>
	)
}

export const percent = (part: number, total: number) =>
	total > 0 ? `${Math.round((part / total) * 10_000) / 100}%`.replace(".", ",") : "0%"
